import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import CommonTable from '../../../../../../components/common-table/CommonTable';
import WritersTableItem from './WritersTableItem';
import Tr from '../../../../../../components/common-table/components/Tr';
import Th from '../../../../../../components/common-table/components/Th';
import CommonPagination from '../../../../../../components/common-pagination/CommonPagination';
import { changeTablePage, changeTableSort } from '../../../../../../redux/settings/scout/scoutSettingsReducer';
import ConfirmationModal from '../../../../../../components/confirmation-modal/ConfirmationModal';
import DeleteLabel from '../../../../../../projects/projects-list/components/DeleteLabel';
import { deleteWriter } from '../../../../../../redux/settings/scout/scoutSettingsActions';
import ThWithSort from '../../../../../../components/common-table/components/ThWithSort';
import calculateSortStr from '../../../../../../utils/calculateSortValue';

import scss from '../WritersList.module.scss';

const WritersTable = () => {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.scoutSettings.isWritersLoading);
  const writers = useSelector((state) => state.scoutSettings.writersList);
  const { page, size, sort } = useSelector((state) => state.scoutSettings.tableSettings);
  const totalElements = useSelector((state) => state.scoutSettings.writersTotal);
  const [selectedWriter, setSelectedWriter] = useState({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleChangeTablePage = useCallback(
    (newPage) => {
      dispatch(changeTablePage(newPage));
    },
    [dispatch],
  );

  const handleChangeSort = useCallback(
    (sortValue) => {
      dispatch(changeTableSort(calculateSortStr({ currentSort: sort, newSortKey: sortValue })));
    },
    [dispatch, sort],
  );

  const handleCloseModals = useCallback(() => {
    setIsDeleteModalOpen(false);
  }, []);

  const handleOpenDeleteModal = useCallback((writer) => {
    setSelectedWriter(writer);
    setIsDeleteModalOpen(true);
  }, []);
  const handleDeleteProject = useCallback(() => {
    dispatch(deleteWriter({ id: selectedWriter.id }));
    setSelectedWriter({});
  }, [dispatch, selectedWriter]);

  return (
    <div>
      <CommonTable
        content={writers}
        isLoading={isLoading}
        renderBody={(item, index) => (
          <WritersTableItem
            key={item.id}
            writer={item}
            rowRank={1 * 0 + (index + 1)}
            onDelete={handleOpenDeleteModal}
          />
        )}>
        <Tr>
          <Th extraClasses='cell-rank'>#</Th>
          <ThWithSort
            label={t('writerName')}
            columnKey='writerName'
            sortStr={sort}
            onSort={handleChangeSort}
            extraThClass={scss.cellName}
            isLeft
          />
          <Th isLeft>{t('phrase')}</Th>
          <ThWithSort
            label={t('status')}
            columnKey='status'
            sortStr={sort}
            onSort={handleChangeSort}
            extraThClass={scss.cell150}
            isLeft
          />
          <ThWithSort
            label={t('lastEdit')}
            columnKey='updatedOn'
            sortStr={sort}
            onSort={handleChangeSort}
            extraThClass={scss.cell150}
            isLeft
          />
          <ThWithSort
            label={t('editedBy')}
            columnKey='updatedBy'
            sortStr={sort}
            onSort={handleChangeSort}
            extraThClass={scss.cell220}
            isLeft
          />
          <Th extraClasses={scss.cellAction} isLeft>
            {t('actions')}
          </Th>
        </Tr>
      </CommonTable>

      <div className={scss.paginationWrapper}>
        <CommonPagination
          activePage={page}
          itemsPerPage={size}
          totalItemsCount={totalElements}
          onChangePage={handleChangeTablePage}
        />
      </div>

      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseModals}
        onCancel={handleCloseModals}
        onConfirm={handleDeleteProject}
        subLabel={<DeleteLabel name={selectedWriter.writerName} />}
      />
    </div>
  );
};

export default WritersTable;
